export const StudioWebHosts = [
    'st-aks-sw-we-tm.trafficmanager.net',
    'st-aks-sw-we-b-dns.westeurope.cloudapp.azure.com',
    'st-aks-sw-we-g-dns.westeurope.cloudapp.azure.com',
    'st-alp-sw-we-b-dns.westeurope.cloudapp.azure.com',
    'st-alp-sw-we-g-dns.westeurope.cloudapp.azure.com',
    'st-alp-sw-ne-dns.northeurope.cloudapp.azure.com',
    'st-stg-sw-we-b-dns.westeurope.cloudapp.azure.com',
    'st-stg-sw-we-g-dns.westeurope.cloudapp.azure.com',
    'st-stg-sw-ne-dns.northeurope.cloudapp.azure.com',
    'stw-prod-sw-ne-b-dns.northeurope.cloudapp.azure.com',
    'stw-prod-sw-ne-g-dns.northeurope.cloudapp.azure.com',
    'stw-prod-sw-we-dns.westeurope.cloudapp.azure.com',
    'sw-prd1-ent-ne-b-dns.northeurope.cloudapp.azure.com',
    'sw-prd1-ent-ne-g-dns.northeurope.cloudapp.azure.com',
    'sw-prd1-ent-we-dns.westeurope.cloudapp.azure.com',
    'sw-prd2-ent-eus-b-dns.eastus2.cloudapp.azure.com',
    'sw-prd2-ent-eus-g-dns.eastus2.cloudapp.azure.com',
    'sw-prd2-ent-cus-dns.centralus.cloudapp.azure.com',
];
